import React from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";

function Dashboard() {
  return (
    <Box
      sx={{
        padding: 3,
        backgroundColor: "#f9fafc", // Light background for the dashboard
        minHeight: "100vh",
      }}
    >
      {/* Header */}

      {/* Stats Grid */}
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <Paper
            sx={{
              padding: 2,
              backgroundColor: "#e3f2fd",
              textAlign: "center",
              borderRadius: 2,
            }}
            elevation={3}
          >
            <Typography variant="h6" sx={{ fontWeight: 500 }}>
              Total Drivers
            </Typography>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", color: "#1976d2" }}
            >
              5
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper
            sx={{
              padding: 2,
              backgroundColor: "#ffecb3",
              textAlign: "center",
              borderRadius: 2,
            }}
            elevation={3}
          >
            <Typography variant="h6" sx={{ fontWeight: 500 }}>
              Active Routes
            </Typography>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", color: "#ffa000" }}
            >
              3
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper
            sx={{
              padding: 2,
              backgroundColor: "#e8f5e9",
              textAlign: "center",
              borderRadius: 2,
            }}
            elevation={3}
          >
            <Typography variant="h6" sx={{ fontWeight: 500 }}>
              Total Shops
            </Typography>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", color: "#43a047" }}
            >
              10
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper
            sx={{
              padding: 2,
              backgroundColor: "#ffccbc",
              textAlign: "center",
              borderRadius: 2,
            }}
            elevation={3}
          >
            <Typography variant="h6" sx={{ fontWeight: 500 }}>
              Inventory
            </Typography>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", color: "#e64a19" }}
            >
              1200 Items
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Dashboard;
